import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  Output,
  SimpleChanges,
  EventEmitter,
  TemplateRef,
  ViewChild,
  NgZone,
  Inject,
  forwardRef
} from '@angular/core';

import { isEqual, isNil, isEmpty, set } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil, mergeMap, shareReplay } from 'rxjs/operators';
import { BaseComponent } from './components/base.component';
import { SharedModule } from './shared.module';import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DatexFormControl, validateControlOnChange, validateFormOnControlChange } from './models/datex-form-control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { FieldsetModel } from './models/fieldset';
import { ToolModel } from './models/tool';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles,
  ValueControlModel
} from './models/control';
import { datCodeValidator } from './components/code-validator.directive';import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { Totes_ShellService } from './Totes.shell.service';
import { Totes_OperationService } from './Totes.operation.service';
import { Totes_DatasourceService } from './Totes.datasource.index';
import { Totes_FlowService } from './Totes.flow.index';
import { Totes_FrontendFlowService } from './Totes.frontend.flow.service';
import { Totes_ReportService } from './Totes.report.index';
import { Totes_LocalizationService } from './Totes.localization.service';
import { Totes_totes_home_ComponentContextService } from './Totes.totes_home.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './Totes.frontend.types'
import { $frontendTypes as $types} from './Totes.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

@Component({
  imports: [
    SharedModule,
  ],
  selector: 'Totes-totes_home',
  templateUrl: './Totes.totes_home.component.html'
})
export class Totes_totes_homeComponent extends BaseComponent implements OnInit, OnDestroy {


  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  //#endregion

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  formGroup: FormGroup = new FormGroup({
  });

  get valid(): boolean {
    return this.formGroup.valid;
  }
  
  toolbar = {
  };

  fields = {
    tote_induction: new FieldModel(new ButtonModel('', new ButtonStyles(null, null), false, false, false, 'Tote induction', 'icon-datex-Tote', null)
, new ControlContainerStyles(null, null), '', false, false),
    tote_picking: new FieldModel(new ButtonModel('', new ButtonStyles(null, null), false, false, false, 'Tote picking', 'icon-datex-Pick', null)
, new ControlContainerStyles(null, null), '', false, false),
  };

  fieldsets = {
    mobile_home: new FieldsetModel(
      'Mobile home',
      false,
      false,
      true,
      false,
        null
      ,
      () => {
        const $form = this;
        const $utils = this.$utils;
        return '';
      }
    ),
};

  //#region fields inParams
  //#endregion fields inParams

  $formGroupFieldValidationObservables = {
  }
  

  constructor(
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: Totes_ShellService,
private $datasources: Totes_DatasourceService,
private $flows: Totes_FlowService,
private $frontendFlows: Totes_FrontendFlowService,
private $reports: Totes_ReportService,
private $localization: Totes_LocalizationService,
private $operations: Totes_OperationService,
private $logger: CleanupLoggerService,
private $context: Totes_totes_home_ComponentContextService,
) { 
    super();
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  initialized = false;

  async $init() {
    this.title = 'Totes home page';
  
    const $form = this;
    const $utils = this.$utils;



    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
  }

  close() {
    this.$finish.emit();
  }

  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }
 
  //#region private flows
  on_tote_induction_button_clicked(event = null) {
    return this.on_tote_induction_button_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_tote_induction_button_clickedInternal(
    $form: Totes_totes_homeComponent,
  
    $shell: Totes_ShellService,
    $datasources: Totes_DatasourceService,
    $flows: Totes_FlowService,
    $frontendFlows: Totes_FrontendFlowService,
    $reports: Totes_ReportService,
    $settings: SettingsValuesService,
    $operations: Totes_OperationService,
    $utils: UtilsService,
    $context: Totes_totes_home_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Totes_LocalizationService,
    $event: any
  ) {
    this.$logger.log('Totes', 'totes_home.on_tote_induction_button_clicked');
  $shell.Totes.opentote_induction_form(true)
  }
  on_tote_picking_button_clicked(event = null) {
    return this.on_tote_picking_button_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_tote_picking_button_clickedInternal(
    $form: Totes_totes_homeComponent,
  
    $shell: Totes_ShellService,
    $datasources: Totes_DatasourceService,
    $flows: Totes_FlowService,
    $frontendFlows: Totes_FrontendFlowService,
    $reports: Totes_ReportService,
    $settings: SettingsValuesService,
    $operations: Totes_OperationService,
    $utils: UtilsService,
    $context: Totes_totes_home_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Totes_LocalizationService,
    $event: any
  ) {
    this.$logger.log('Totes', 'totes_home.on_tote_picking_button_clicked');
  $shell.Totes.opentote_picking_form(true)
  }
  //#endregion private flows
}
